import { FC } from "react";

import { CaptionedLoaderAnimationStyles } from "./captioned-loader.animations";
import {
  CAPTIONED_LOADER_CENTER,
  CAPTIONED_LOADER_GUIDE_RADIUS,
  CAPTIONED_LOADER_INNER_RADIUS,
  CAPTIONED_LOADER_MIDDLE_RADIUS,
  CAPTIONED_LOADER_OUTER_RADIUS,
  CAPTIONED_LOADER_SIZE,
} from "./captioned-loader.constants";
import { CaptionedLoaderStyled } from "./captioned-loader.styled";

export interface ICaptionedLoaderProps {
  caption: string;
}
export const CaptionedLoader: FC<ICaptionedLoaderProps> = ({ caption }) => (
  <>
    <CaptionedLoaderAnimationStyles />
    <CaptionedLoaderStyled>
      <div
        className="ryde-captioned-loader__spinner"
        role="status"
        aria-live="polite"
      >
        <svg
          className="ryde-captioned-loader__svg"
          width={CAPTIONED_LOADER_SIZE}
          height={CAPTIONED_LOADER_SIZE}
          viewBox={`0 0 ${CAPTIONED_LOADER_SIZE} ${CAPTIONED_LOADER_SIZE}`}
          aria-hidden
        >
          <circle
            className="ryde-captioned-loader__guide"
            cx={CAPTIONED_LOADER_CENTER}
            cy={CAPTIONED_LOADER_CENTER}
            r={CAPTIONED_LOADER_GUIDE_RADIUS}
          />
        </svg>
        <div className="ryde-captioned-loader__ring-layer ryde-captioned-loader__ring-layer--outer">
          <svg
            className="ryde-captioned-loader__svg"
            width={CAPTIONED_LOADER_SIZE}
            height={CAPTIONED_LOADER_SIZE}
            viewBox={`0 0 ${CAPTIONED_LOADER_SIZE} ${CAPTIONED_LOADER_SIZE}`}
            aria-hidden
          >
            <circle
              className="ryde-captioned-loader__arc"
              cx={CAPTIONED_LOADER_CENTER}
              cy={CAPTIONED_LOADER_CENTER}
              r={CAPTIONED_LOADER_OUTER_RADIUS}
            />
            <circle
              className="ryde-captioned-loader__arc ryde-captioned-loader__arc--offset"
              cx={CAPTIONED_LOADER_CENTER}
              cy={CAPTIONED_LOADER_CENTER}
              r={CAPTIONED_LOADER_OUTER_RADIUS}
            />
          </svg>
        </div>
        <div className="ryde-captioned-loader__ring-layer ryde-captioned-loader__ring-layer--middle">
          <svg
            className="ryde-captioned-loader__svg"
            width={CAPTIONED_LOADER_SIZE}
            height={CAPTIONED_LOADER_SIZE}
            viewBox={`0 0 ${CAPTIONED_LOADER_SIZE} ${CAPTIONED_LOADER_SIZE}`}
            aria-hidden
          >
            <circle
              className="ryde-captioned-loader__arc"
              cx={CAPTIONED_LOADER_CENTER}
              cy={CAPTIONED_LOADER_CENTER}
              r={CAPTIONED_LOADER_MIDDLE_RADIUS}
            />
            <circle
              className="ryde-captioned-loader__arc ryde-captioned-loader__arc--offset"
              cx={CAPTIONED_LOADER_CENTER}
              cy={CAPTIONED_LOADER_CENTER}
              r={CAPTIONED_LOADER_MIDDLE_RADIUS}
            />
          </svg>
        </div>
        <div className="ryde-captioned-loader__ring-layer ryde-captioned-loader__ring-layer--inner">
          <svg
            className="ryde-captioned-loader__svg"
            width={CAPTIONED_LOADER_SIZE}
            height={CAPTIONED_LOADER_SIZE}
            viewBox={`0 0 ${CAPTIONED_LOADER_SIZE} ${CAPTIONED_LOADER_SIZE}`}
            aria-hidden
          >
            <circle
              className="ryde-captioned-loader__arc"
              cx={CAPTIONED_LOADER_CENTER}
              cy={CAPTIONED_LOADER_CENTER}
              r={CAPTIONED_LOADER_INNER_RADIUS}
            />
            <circle
              className="ryde-captioned-loader__arc ryde-captioned-loader__arc--offset"
              cx={CAPTIONED_LOADER_CENTER}
              cy={CAPTIONED_LOADER_CENTER}
              r={CAPTIONED_LOADER_INNER_RADIUS}
            />
          </svg>
        </div>
      </div>
      <p className="ryde-captioned-loader__caption">{caption}</p>
    </CaptionedLoaderStyled>
  </>
);
